import { render, staticRenderFns } from "./side-panel-menu.vue?vue&type=template&id=9f6d6a28&scoped=true&"
import script from "./side-panel-menu.vue?vue&type=script&lang=js&"
export * from "./side-panel-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6d6a28",
  null
  
)

export default component.exports